module.exports = __webpack_public_path__ + "img/Rellena_Microconcreto R200.b36386c1.png";